export default {
      id: "NRF-usage",
      viewBox: "0 0 291 246",
      url: __webpack_public_path__ + "sprite.svg#NRF",
      toString: function () {
        return this.url;
      }
    }